import { Link } from 'react-router-dom';

export default function SafetySection() {
  const imageUrl = 'https://readdy.ai/api/search-image?query=Clean%20modern%20secure%20workspace%20with%20laptop%20displaying%20shield%20security%20icon%2C%20organized%20desk%20with%20notebook%20and%20pen%2C%20warm%20natural%20sunlight%20through%20window%2C%20cream%20colored%20walls%2C%20light%20wood%20desk%20surface%2C%20small%20green%20plant%20for%20freshness%2C%20editorial%20cybersecurity%20lifestyle%20photography%2C%20soft%20gentle%20shadows%2C%20warm%20golden%20tones%2C%20peaceful%20trustworthy%20atmosphere%2C%20high%20detail%20refined%20composition&width=800&height=600&seq=vigorbuy-safety-2026-v3&orientation=landscape';
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-4">
              <i className="ri-shield-check-line w-3.5 h-3.5 flex items-center justify-center"></i>
              Safety First
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-4">
              Is VigorBuy Safe? What You Need to Know
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              VigorBuy users should always verify information, compare options, review quality checks,
              and use trusted resources before making purchasing decisions. Understanding the platform
              and following best practices helps ensure a smooth experience.
            </p>
            <ul className="space-y-2 mb-6">
              {[
                'Always verify product details before purchasing',
                'Review quality check (QC) photos when available',
                'Compare multiple options within each category',
                'Use trusted shipping methods with tracking',
                'Read community feedback and reviews',
              ].map((tip) => (
                <li key={tip} className="flex items-start gap-2 text-sm text-foreground-700">
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center text-accent-500 mt-0.5 flex-shrink-0"></i>
                  {tip}
                </li>
              ))}
            </ul>
            <Link
              to="/vigorbuy-safety-tips/"
              className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              Read Full Safety Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>

          <div className="flex-1 w-full">
            <div
              className="w-full aspect-[4/3] rounded-lg bg-cover bg-center"
              style={{
                backgroundImage: `url('${imageUrl}')`,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}